module.exports = __webpack_public_path__ + "static/img/14000286.08f1146c.png";